<h1 class="page-title">Checkout and Pay</h1>
<p>{{user.fullName}} at {{user.email}}</p>
<app-product-list [showRemove]="true"></app-product-list>
<div *ngIf="products.length > 0" class="form-actions">
  <button class="button button--secondary form-actions__item" type="button" (click)="onCancel()">Cancel</button>
  <button class="button form-actions__item" (click)="onCheckout()">Checkout</button>
</div>